import { Component } from '@angular/core';
import { ResourceListComponent } from '../../shared/resource-list/resource-list.component';

@Component({
  selector: 'app-integrations',
  standalone: true,
  imports: [ResourceListComponent],
  template: `<app-resource-list title="Integrations" apiPath="integrations" />`
})
export class IntegrationsComponent {}
